const AUTH_TOKEN_STORAGE_KEY = 'fitbase_token';
const AUTH_PHONE_STORAGE_KEY = 'fitbase-booking-widget-auth-phone';
export const AUTH_CHANGE_EVENT = 'fitbase-auth-changed';
let missingClubIdLogged = false;

function emitAuthChange() {
    if (typeof window === 'undefined') {
        return;
    }
    window.dispatchEvent(new CustomEvent(AUTH_CHANGE_EVENT, {
        detail: {
            token: getStoredAuthToken(),
            phone: getStoredAuthPhone()
        }
    }));
}
function getCurrentHostname() {
    if (typeof window === 'undefined') {
        return '';
    }
    return window.location.hostname.toLowerCase();
}
function getCurrentSubdomain() {
    const hostname = getCurrentHostname();
    return hostname.split('.').filter(Boolean)[0] || '';
}
function isLocalHostname(hostname) {
    return hostname === 'localhost' || hostname.endsWith('.fitbase.local');
}
export function isLocalRuntimeHost() {
    return isLocalHostname(getCurrentHostname());
}
function resolveDefaultClubAlias() {
    if (typeof window === 'undefined') {
        return 'demo';
    }
    const subdomain = getCurrentSubdomain();
    if (isLocalRuntimeHost()) {
        return 'demo';
    }
    if (subdomain === 'pandem1c' || subdomain === 'staging-test' || subdomain === 'staging' || subdomain === 'test' || subdomain === 'predprod') {
        return subdomain;
    }
    return subdomain || 'demo';
}
const defaultClubAlias = resolveDefaultClubAlias();
function resolveDefaultDomain() {
    if (typeof window === 'undefined') {
        return '';
    }
    const subdomain = getCurrentSubdomain();
    if (subdomain === 'pandem1c') {
        return 'https://api.pandem1c.devops.fitbase.io';
    }
    if (subdomain === 'staging-test') {
        return 'https://api-staging-test.dev.fitbase.team';
    }
    if (subdomain === 'staging') {
        return 'https://api-staging.dev.fitbase.team';
    }
    if (subdomain === 'test') {
        return 'https://api-test.devops.fitbase.io';
    }
    if (isLocalRuntimeHost()) {
        return 'http://api.fitbase.local';
    }
    if (subdomain === 'predprod') {
        return 'https://api.predprod.dev.fitbase.team';
    }
    return 'https://api.fitbase.io';
}
const defaultDomain = resolveDefaultDomain();
const runtimeConfig = {
    domain: defaultDomain,
    club: defaultClubAlias,
    clubId: undefined,
    theme: 'light',
    userId: undefined
};
export function setRuntimeConfig(config) {
    runtimeConfig.domain = config.domain || runtimeConfig.domain;
    runtimeConfig.club = config.club || runtimeConfig.club;
    if (Object.prototype.hasOwnProperty.call(config, 'clubId') || Object.prototype.hasOwnProperty.call(config, 'filialId')) {
        const nextClubId = config.clubId ?? config.filialId;
        runtimeConfig.clubId = Number.isFinite(nextClubId) && nextClubId > 0 ? nextClubId : undefined;
    }
    runtimeConfig.theme = config.theme || runtimeConfig.theme;
    runtimeConfig.userId = config.userId;
}
export function getRuntimeConfig() {
    return runtimeConfig;
}
export function hasRuntimeClubId() {
    return Number.isFinite(runtimeConfig.clubId) && runtimeConfig.clubId > 0;
}
export function logMissingClubId() {
    if (missingClubIdLogged) {
        return;
    }
    missingClubIdLogged = true;
    console.error('[booking-widget] club-id is required. Widget requests are disabled until a valid club-id is provided.');
}
export function getStoredAuthToken() {
    if (typeof window === 'undefined') {
        return null;
    }
    return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}
export function setStoredAuthToken(token) {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    emitAuthChange();
}
export function clearStoredAuthToken() {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    emitAuthChange();
}
export function getStoredAuthPhone() {
    if (typeof window === 'undefined') {
        return null;
    }
    return window.localStorage.getItem(AUTH_PHONE_STORAGE_KEY);
}
export function setStoredAuthPhone(phone) {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(AUTH_PHONE_STORAGE_KEY, phone);
    emitAuthChange();
}
export function clearStoredAuthPhone() {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.removeItem(AUTH_PHONE_STORAGE_KEY);
    emitAuthChange();
}
